export const momentRelativeTime = {
  future: 'in %s',
  past: '%s ago',
  s: 'a few sec',
  ss: '%d sec',
  m: '%d min',
  mm: '%d min',
  h: '%dh',
  hh: '%dh',
  d: '%d',
  dd: '%dd',
  M: '1mo',
  MM: '%dmo',
  y: '1y',
  yy: '%dy',
};
